<template>
  <Modal
    :value="showModal"
    :title="'Edit Family Account'"
    :loading="loading"
    :closable="false"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
  >
    <Form ref="FamilyForm" :model="familyForm" :rules="familyRules">
      <FormItem prop="Email" label="Mail Address">
        <i-input
          v-model="familyForm.mailAddress"
          type="email"
          placeholder="Email"
          :readonly="true"
          :disabled="true"
        ></i-input>
      </FormItem>
      <FormItem prop="NewPassword" label="New Password">
        <i-input
          v-model="familyForm.NewPassword"
          type="password"
          placeholder="new password"
        ></i-input>
      </FormItem>
      <FormItem prop="ConfirmNewPassword" label="Confirm New Password">
        <i-input
          v-model="familyForm.ConfirmNewPassword"
          type="password"
          placeholder="confirm new password"
        ></i-input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="handleCancel">Cancel</Button>
      <Button
        type="primary"
        :loading="submitLoading"
        style="margin-left: 8px"
        @click="handleUpdate"
      >
        <span v-if="!submitLoading">Update</span>
        <span v-else>Processing...</span>
      </Button>
    </div>
  </Modal>
</template>

<script>
import { Helper } from "../../_helpers";

import { updateFamily } from "../../_services/family.service";

export default {
  data() {
    const validateConfirmPassword = async (rule, value, callback) => {
      try {
        if (this.familyForm.NewPassword !== value) {
          throw new Error("Did not match with the new password.");
        }
        callback();
      } catch (err) {
        callback(new Error("Did not match with the new password."));
      }
    };
    return {
      showModal: false,
      loading: false,
      submitLoading: false,
      familyForm: {
        Name: "",
        Email: "",
        Password: ""
      },
      familyRules: {
        ConfirmNewPassword: [
          { validator: validateConfirmPassword, trigger: "blur" }
        ]
      },
      familyData: {
        Name: "",
        Email: "",
        Password: ""
      },
      toUpdate: false
    };
  },
  methods: {
    triggerModal() {
      this.showModal = true;
    },
    triggerUpdateModal(family) {
      let vm = this;
      let cpFamily = Object.assign({}, family);
      this.showModal = true;
      vm.familyForm = cpFamily;
      vm.familyData = family;
    },
    handleUpdate() {
      const updatedFamilyForm = Helper._objectDiffer(
        this.familyForm,
        this.familyData
      );

      // new password provided
      if (
        updatedFamilyForm.NewPassword &&
        updatedFamilyForm.NewPassword !== ""
      ) {
        this.$refs.FamilyForm.validate(valid => {
          if (valid) {
            this.submitLoading = true;

            updateFamily(this.familyData.id, {
              NewPassword: updatedFamilyForm.NewPassword,
              ConfirmNewPassword: updatedFamilyForm.ConfirmNewPassword
            })
              .then(res => {
                this.showModal = false;
                this.submitLoading = false;
                this.$Message.success(
                  "Family account password successfully updated!"
                );
              })
              .catch(err => {
                this.showModal = false;
                this.submitLoading = false;
                this.$Message.error(
                  "Failed to update Family password. Please try again later."
                );
              });
          }
        });
      } else {
        this.showModal = false;
      }
    },
    handleCancel() {
      this.showModal = false;
      this.$refs.FamilyForm.resetFields();
    },
    onVisibleChange(val) {
      if (!val) {
        this.familyForm = {
          Name: "",
          Email: "",
          Password: ""
        };
        this.$refs.FamilyForm.resetFields();
      }
    }
  }
};
</script>
